<div class="clientWrapper">
    <app-client-sidebar class="sidebar"></app-client-sidebar>
    <app-client-navbar class="navbar"></app-client-navbar>
    <router-outlet class="outlet"></router-outlet>
</div>